// Right-hand nav slot: the signed-in chip, or the Sign In trigger.
//
// While the session is still being checked this renders nothing, so a returning
// user never sees a Sign In button flash before their name resolves.
export function UserBar({ user, loading, onSignIn, onSignOut }) {
  if (loading) return <div className="user-bar" />;

  if (!user) {
    return (
      <div className="user-bar">
        <button className="login-btn" title="Sign in" onClick={onSignIn}>
          Sign In
        </button>
      </div>
    );
  }

  const displayName = user.name || user.email;

  return (
    <div className="user-bar">
      <a href="/dashboard.html" className="dashboard-link" title="Dashboard">
        Dashboard
      </a>
      <div className="user-chip">
        {user.picture && <img src={user.picture} alt="" />}
        <span className="user-name">{displayName}</span>
        <button className="logout-x" title="Sign out" onClick={onSignOut}>
          &times;
        </button>
      </div>
    </div>
  );
}
